// generated by the plop

import { PROGRESS_STATUSES } from 'symbols';
import { DirectoryAddressModel } from '../../symbols';

export interface DirectoryAddressesStateModel {
  currentAddressesStreet: DirectoryAddressModel[];
  currentAddressesCountry: DirectoryAddressModel[];
  currentAddressesCity: DirectoryAddressModel[];
  loadAddressesStatus: PROGRESS_STATUSES;
}

export const DIRECTORY_ADDRESSES_STATE_DEFAULT: DirectoryAddressesStateModel = {
  currentAddressesStreet: [],
  currentAddressesCountry: [],
  currentAddressesCity: [],
  loadAddressesStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
